import { sdkApi } from 'redux-stores/api';
import { SearchResults } from 'types/api';
import TCClient from 'client';
import { type LocationT } from 'js-sdk/src/types/Locations';

export const locationsApi = sdkApi.injectEndpoints({
  endpoints: (build) => ({
    getLocations: build.query<
      SearchResults<LocationT>,
      { orgId: string; startIndex: number; count: number }
    >({
      queryFn: async ({ orgId, startIndex, count }, _queryApi) => {
        const res = await TCClient.location.getOrganizationLocations({
          orgId: orgId || '',
          startIndex: startIndex,
          count: count,
        });
        return { data: res };
      },
      serializeQueryArgs: ({ queryArgs }) => {
        const { orgId } = queryArgs;
        return { orgId };
      },
      merge: (currentCache, newItems) => {
        if (newItems.metadata.firstHit === 1) {
          currentCache.results = newItems.results;
          currentCache.metadata = newItems.metadata;
        } else {
          currentCache.results.push(...newItems.results);
          currentCache.metadata = newItems.metadata;
        }
      },
      forceRefetch({ currentArg, previousArg }) {
        return true;
      },
    }),
    updateLocationPersonas: build.mutation<
      void,
      {
        orgId: string;
        locationId: string;
        locationType: string;
        associationsToAdd: string[];
        associationsToRemove: string[];
      }
    >({
      queryFn: async (
        { orgId, locationId, locationType, associationsToAdd, associationsToRemove },
        _queryApi
      ) => {
        try {
          const res = await TCClient.location.updateLocationPersonas({
            orgId,
            locationId,
            locationType,
            associationsToAdd,
            associationsToRemove,
          });
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
    }),
  }),
  overrideExisting: true,
});
export const { useGetLocationsQuery, useUpdateLocationPersonasMutation } = locationsApi;
